import { styled } from "@stitches/react";

export const SocialButton = styled("a", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 10px 20px -10px #1DA1F2",
  background: "#1DA1F2",
  transition: "background-color 0.3s, box-shadow 0.3s",
  color: "#fff",
  textDecoration: "none",
  borderRadius: 99999,
  padding: "1.5rem 2.5rem",
  fontWeight: 600,
  fontSize: "1.2rem",
  maxWidth: 180,
  minWidth: 180,

  "&:hover": {
    background: "#1397E8",
    boxShadow: "0 20px 30px -20px #1397E8",
  },

  ".icon": {
    marginRight: "0.7rem",
  },

  ".arrow": {
    position: "absolute",
    right: "1.5rem",
  },

  variants: {
    disable: {
      true: {
        color: "#8C8C8C",
        ".icon": {
          opacity: 0.3,
        },
      },
    },
  },
});

export function SoonIcon({ width = 34, height = 18, color = "#000" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 65 18"
      fill={color}
      className="arrow"
    >
      <path
        opacity="0.6"
        d="M2.61768 11.9141C2.6984 12.8223 2.92546 13.5186 3.29883 14.0029C3.98503 14.8809 5.17578 15.3198 6.87109 15.3198C7.88021 15.3198 8.76823 15.1029 9.53516 14.6689C10.3021 14.2249 10.6855 13.5438 10.6855 12.6255C10.6855 11.9292 10.3778 11.3994 9.76221 11.0361C9.36865 10.8141 8.59163 10.5568 7.43115 10.2642L5.2666 9.71924C3.88411 9.37614 2.86491 8.99268 2.20898 8.56885C1.03841 7.83219 0.453125 6.81299 0.453125 5.51123C0.453125 3.97738 1.00309 2.73617 2.10303 1.7876C3.21305 0.83903 4.7015 0.364746 6.56836 0.364746C9.01042 0.364746 10.7713 1.08122 11.8511 2.51416C12.5272 3.42236 12.8551 4.4012 12.835 5.45068H10.2617C10.2113 4.83512 9.9943 4.27507 9.61084 3.77051C8.98519 3.05404 7.90039 2.6958 6.35645 2.6958C5.32715 2.6958 4.54508 2.89258 4.01025 3.28613C3.48551 3.67969 3.22314 4.19938 3.22314 4.84521C3.22314 5.5516 3.57129 6.1167 4.26758 6.54053C4.67122 6.79281 5.2666 7.01481 6.05371 7.20654L7.85498 7.64551C9.81266 8.11979 11.1245 8.57894 11.7905 9.02295C12.8501 9.71924 13.3799 10.8141 13.3799 12.3076C13.3799 13.7507 12.8299 14.9969 11.73 16.0464C10.6401 17.0959 8.9751 17.6206 6.73486 17.6206C4.32308 17.6206 2.61263 17.0757 1.60352 15.9858C0.604492 14.8859 0.0696615 13.5286 -0.000976562 11.9141H2.61768ZM22.9312 15.2441C24.7375 15.2441 25.9736 14.563 26.6396 13.2007C27.3158 11.8283 27.6538 10.3045 27.6538 8.62939C27.6538 7.11572 27.4116 5.8846 26.9272 4.93604C26.1603 3.44255 24.8384 2.6958 22.9614 2.6958C21.2964 2.6958 20.0854 3.33154 19.3286 4.60303C18.5718 5.87451 18.1934 7.40837 18.1934 9.20459C18.1934 10.9302 18.5718 12.3682 19.3286 13.5186C20.0854 14.6689 21.2863 15.2441 22.9312 15.2441ZM23.0371 0.319336C25.126 0.319336 26.8919 1.01562 28.335 2.4082C29.778 3.80078 30.4995 5.84928 30.4995 8.55371C30.4995 11.1673 29.8638 13.3268 28.5923 15.0322C27.3208 16.7376 25.348 17.5903 22.6738 17.5903C20.4437 17.5903 18.6727 16.8385 17.3608 15.335C16.049 13.8213 15.3931 11.793 15.3931 9.25C15.3931 6.52539 16.0843 4.35579 17.4668 2.74121C18.8493 1.12663 20.7061 0.319336 23.0371 0.319336ZM40.187 15.2441C41.9933 15.2441 43.2295 14.563 43.8955 13.2007C44.5716 11.8283 44.9097 10.3045 44.9097 8.62939C44.9097 7.11572 44.6675 5.8846 44.1831 4.93604C43.4162 3.44255 42.0942 2.6958 40.2173 2.6958C38.5522 2.6958 37.3413 3.33154 36.5845 4.60303C35.8276 5.87451 35.4492 7.40837 35.4492 9.20459C35.4492 10.9302 35.8276 12.3682 36.5845 13.5186C37.3413 14.6689 38.5422 15.2441 40.187 15.2441ZM40.293 0.319336C42.3818 0.319336 44.1478 1.01562 45.5908 2.4082C47.0339 3.80078 47.7554 5.84928 47.7554 8.55371C47.7554 11.1673 47.1196 13.3268 45.8481 15.0322C44.5767 16.7376 42.6038 17.5903 39.9297 17.5903C37.6995 17.5903 35.9285 16.8385 34.6167 15.335C33.3049 13.8213 32.6489 11.793 32.6489 9.25C32.6489 6.52539 33.3402 4.35579 34.7227 2.74121C36.1051 1.12663 37.9619 0.319336 40.293 0.319336ZM51.0098 0.788574H53.5981V3.08936C54.3651 2.14079 55.1774 1.45964 56.0352 1.0459C56.8929 0.632161 57.8465 0.425293 58.896 0.425293C61.1968 0.425293 62.7508 1.22754 63.5581 2.83203C64.0021 3.70996 64.2241 4.96631 64.2241 6.60107V17H61.4541V6.78271C61.4541 5.79378 61.3078 4.99658 61.0151 4.39111C60.5308 3.382 59.6528 2.87744 58.3813 2.87744C57.7355 2.87744 57.2057 2.94303 56.792 3.07422C56.0452 3.29622 55.3893 3.74023 54.8242 4.40625C54.3701 4.94108 54.0724 5.49609 53.9312 6.07129C53.8 6.63639 53.7344 7.44873 53.7344 8.5083V17H51.0098V0.788574Z"
        fill="black"
      />
    </svg>
  );
}

export function ArrowIcon({ width = 18, height = 18, color = "#000" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 32"
      fill={color}
      className="arrow"
    >
      <path
        d="M20.8821 32L36.7912 16.0909L20.8821 0.181819L18.1477 2.91619L29.4048 14.1378H0.25V18.044H29.4048L18.1477 29.3011L20.8821 32Z"
        fill="black"
      />
    </svg>
  );
}

export function GithubIcon({ width = 32, height = 32, color = "#000" }) {
  return (
    <svg
      fill={color}
      className="icon"
      viewBox="0 0 24 24"
      width={width}
      height={height}
    >
      <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
    </svg>
  );
}

export function TwitterIcon({ width = 32, height = 32, color = "#000" }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" className="icon">
      <path
        fill={color}
        d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"
      />
    </svg>
  );
}
